import React from 'react';
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

interface ProjectSearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onClearSearch: () => void;
}

export default function ProjectSearchBar({ searchTerm, onSearchChange, onClearSearch }: ProjectSearchBarProps) {
  const { t } = useTranslation('project');

  return (
    <div className="w-full sm:w-80">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="block w-full pl-10 pr-10 py-2 border border-border-subtle rounded-md leading-5 bg-bg-form placeholder-gray-400 focus:outline-none focus:placeholder-gray-300 focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm text-gray-50"
          placeholder={t('searchPlaceholder')}
        />
        {searchTerm && (
          <button
            type="button"
            onClick={onClearSearch}
            className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
          >
            <XMarkIcon className="h-5 w-5 text-gray-400 hover:text-gray-300" />
          </button>
        )}
      </div>
    </div>
  );
}
